import { useEffect, useMemo, useRef } from "react";
import useSWR from "swr";
import { fetcher } from "@/lib/api";
import { useSoundPref, useAlertChime } from "@/lib/traffic";

// One shared live poller for status, alerts (with chime) and the vehicle feed.
export function useLive() {
  const { data: live, mutate } = useSWR("/traffic/live", fetcher, { refreshInterval: 5000 });
  const { data: settings } = useSWR("/traffic/settings", fetcher, { refreshInterval: 60000 });
  const { data: feed } = useSWR("/traffic/feed?limit=40", fetcher, { refreshInterval: 3000 });
  const { data: spark } = useSWR("/traffic/sparklines", fetcher, { refreshInterval: 10000 });
  const { enabled } = useSoundPref();
  const alerts = useMemo(() => live?.alerts || [], [live]);
  useAlertChime(alerts, enabled && (settings?.sound_enabled ?? true), settings?.sound_volume ?? 0.6);
  const ref = useRef(mutate);
  useEffect(() => { ref.current = mutate; }, [mutate]);
  return { live, feed, spark, settings, refresh: () => ref.current() };
}
